<template>
    <div class="ui message positive">
        You've earned {{ points }} point<span v-if="points > 1">s</span>! Check out the <a class='leaderboard-link' href="#" @click="leaderboardClick">leaderboard</a> to see how you compare.
    </div>
</template>
<script>
export default {
    name: 'PointsMessage',
    methods: {
        closeMessage: function() {
            this.visible = false
        },
        showMessage: function() {
            this.visible = true
        },
        leaderboardClick: function() {
            this.$bubble('showLeaderboard')
        }
    },
    data() {
        return {
            visible: false
        }
    },
    props: [ 'points' ]
}
</script>
<style scoped>

@media (max-width: 640px) {
    .ui.message {
        margin: 0px !important;
    }
}

</style>